import { render, staticRenderFns } from "./labelListingNew.vue?vue&type=template&id=225611eb&"
import script from "./labelListingNew.vue?vue&type=script&lang=js&"
export * from "./labelListingNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports